/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';

class TrialEndingModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {

        if (typeof(Storage) !== undefined) {
			sessionStorage.setItem('trialEndingAcknowledged', true);
		}

        this.props.dismissModal();

    }

    render() {
        let modalContent = null,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            dayCopy = (this.props.user.detail.trialDaysLeft != 1) ? 'days' : 'day',
            mainCopy = '';

        if (this.props.user.detail.trialDaysLeft === 0) {
            let now = new moment().tz(this.props.user.detail.timezone),
                trialEnd = new moment(this.props.user.detail.trialEnd).tz(this.props.user.detail.timezone),
                diff = trialEnd.diff(now, 'hours');

            if (diff === 0) {
                diff = trialEnd.diff(now, 'minutes');
                if (diff < 0) {
                    mainCopy = <span>Your trial has ended.</span>
                } else {
                    let minuteLabel = (diff === 1) ? 'minute' : 'minutes';
                    mainCopy = <span>Your trial ends in {diff} {minuteLabel}.</span>
                }
            } else {
                let hourLabel = (diff === 1) ? 'hour' : 'hours';
                mainCopy = <span>Your trial ends in {diff} {hourLabel}.</span>
            }


        } else {
            mainCopy = <span>Your trial ends in {this.props.user.detail.trialDaysLeft} {dayCopy}.</span>
        }

        modalContent = (
            <div className="trial-end-warning">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="big-icon">
                    <img src={`${imageUrl}/upgrade-modal/trial-end-hourglass.svg`} width="175" height="auto"/>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>{mainCopy}</h3>
                    <p>Choose a plan now and keep the posts flowing to your social media profiles.</p>
                </div>
                <div className="warning-dismiss" onClick={(e) => {
                    this.dismissModal(e);
                    this.props.router.navigate("/account/subscription/new");
                }} role="button" aria-label="subscribe">
                    View Plans
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-end-box"}
                mainClass={"trial-end-content"} />
        );
    }
}

TrialEndingModal.displayName = "TrialEndingModal";

export default TrialEndingModal;
